import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class PlantingSiteService {
    constructor(requestService) {
        this.requestService = requestService;
    }
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites');
            return result.data;
        });
    }
    getById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/' + id);
            return result.data;
        });
    }
    save(site) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                title: site.title,
                description: site.description,
                country: site.country,
                region: site.region,
                ngoPartnerIds: site.partners.map(partner => partner.ngoPartnerId),
                communityOwner: site.landOwner,
                communityOwnerDescription: site.landOwnerDescription,
                plantingDate: site.plantingDate,
                singleDonorMessage: site.singleDonorMessage,
                totalTrees: site.totalTrees,
                lat: site.lat,
                lon: site.lon,
                photoPosition: site.photoPosition,
                code: site.code,
                pdfUrl: site.pdfUrl,
                enabledBanner: site.enabledBanner,
                bannerHeader: site.bannerHeader,
                bannerDescription: site.bannerDescription
            };
            if (site.id) {
                yield this.requestService.patch('plantingSites/update-planting-site', Object.assign({ plantingSiteId: site.id }, data));
                return site.id;
            }
            else {
                let result = yield this.requestService.post('plantingSites/create-planting-site', data);
                return result.data;
            }
        });
    }
    addPlantingSiteArea(plantingSiteAreaFormData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.post('plantingSites/create-planting-site-area', plantingSiteAreaFormData);
            return result.data;
        });
    }
    updatePlantingSiteArea(plantingSiteArea) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.patch('plantingSites/update-planting-site-area', plantingSiteArea);
            return result.data;
        });
    }
    deletePlantingSiteArea(platingSiteAreaId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('plantingSites/delete-planting-site-area/' + platingSiteAreaId);
            return result.data;
        });
    }
    updatePlantedTreesPhoto(file, siteId) {
        let formData = new FormData();
        formData.append('SpeciesPhoto', file, file.name);
        formData.append('SpeciesId', siteId);
        return this.requestService.post('plantingSites/upload-planted-trees-photo', formData);
    }
    getSpeciesById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/plating-species/' + id);
            return result.data;
        });
    }
    addCertificate(siteId, certificate) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.post('certificates/create-planting-site-certificate', Object.assign({ plantingSiteId: siteId }, certificate));
            return result.data;
        });
    }
    updateCertificate(certificate) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.requestService.patch('certificates/update-planting-site-certificate', certificate);
            return certificate.id;
        });
    }
    deletCertificate(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('certificates/delete-planting-site-certificate/' + id);
            return result.data;
        });
    }
    deletDocument(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('plantingSites/delete-planting-site-document/' + id);
            return result.data;
        });
    }
    uploadCollectionPhoto(file, collectionId, lat, lon) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let formData = new FormData();
            formData.append('photo', file, file.name);
            formData.append('photoCollectionId', collectionId);
            formData.append('lat', lat.toString());
            formData.append('lon', lon.toString());
            let result = yield this.requestService.post('photoCollection/add-photo-to-collection', formData);
            return result.data;
        });
    }
    setCollectionThumbnail(collectionId, photoId) {
        return this.requestService.patch(`photoCollection/set-thumbnail/${collectionId}?photoId=${photoId}`, null);
    }
    updateSitePhoto(file, siteId) {
        let formData = new FormData();
        formData.append('headerPhoto', file, file.name);
        formData.append('plantingSiteId', siteId);
        return this.requestService.post('plantingSites/upload-planting-site-header-photo', formData);
    }
    updateLandOwnerPhoto(file, siteId) {
        let formData = new FormData();
        formData.append('LandOwnerPhoto', file, file.name);
        formData.append('plantingSiteId', siteId);
        return this.requestService.post('plantingSites/upload-planting-site-land-owner-photo', formData);
    }
    updateSitePDF(file, siteId) {
        let formData = new FormData();
        formData.append('pdfFile', file, file.name);
        formData.append('plantingSiteId', siteId);
        return this.requestService.post('plantingSites/upload-planting-site-pdf', formData);
    }
    deleteLandOwnerPhoto(siteId) {
        return this.requestService.delete('plantingSites/delete-land-owner-photo?plantingSiteId=' + siteId);
    }
    updatePlantingSiteAreaPhoto(file, siteId) {
        let formData = new FormData();
        formData.append('coverPhoto', file, file.name);
        formData.append('plantingSiteAreaId', siteId);
        return this.requestService.post('plantingSites/upload-planting-site-area-photo', formData);
    }
    getCountries() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/countries');
            return result.data;
        });
    }
    getRegions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/regions');
            return result.data;
        });
    }
    getAllSpecies() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/get-all-planting-site-species');
            return result.data;
        });
    }
    saveSpecies(species, plantingSiteId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                speciesId: species.speciesId,
                count: species.count,
                species: species.species,
                description: species.description
            };
            if (species.id) {
                yield this.requestService.patch('plantingSites/update-planting-site-species', Object.assign({ id: species.id }, data));
                return species.id;
            }
            else {
                let result = yield this.requestService.post('plantingSites/create-planting-site-species', Object.assign({ plantingSiteId: plantingSiteId }, data));
                return result.data;
            }
        });
    }
    deleteSpecies(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('plantingSites/delete-planting-site-species?id=' + id);
            return result.data;
        });
    }
    deletePlantingSite(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('plantingSites/delete-planting-site?plantingSiteId=' + id);
            return result.data;
        });
    }
    getFlightPathData(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('plantingSites/flight-path/' + id);
            return result.data;
        });
    }
    createSpeies(name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.post('plantingSites/create-species', { name: name });
            return result.data;
        });
    }
}
PlantingSiteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlantingSiteService_Factory() { return new PlantingSiteService(i0.ɵɵinject(i1.RequestService)); }, token: PlantingSiteService, providedIn: "root" });
